module.exports = __webpack_public_path__ + "img/Y004.cc337005.jpg";